import $ from 'jquery';
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const outline = () => {
    const swiperContainer = document.querySelector('.js-outline-swiper');
    if (!swiperContainer) return;

    const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    // Swiper初期化
    const swiper = new Swiper(swiperContainer, {
        modules: [Autoplay],
        loop: true,
        speed: 10000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        freeMode: true,
        freeModeMomentum: false,
        allowTouchMove: true,

        // --- ここでブレークポイントを定義 ---
        slidesPerView: 6,
        breakpoints: {
            0: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
        },
    });

    // CSSトランジションを滑らかに
    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (wrapper) {
        wrapper.style.transitionTimingFunction = 'linear';
    }
};

const videoModal = () => {
    const triggers = document.querySelectorAll('.js-video-trigger');
    const modal = document.querySelector('.js-video-modal');
    const iframe = document.querySelector('.js-video-iframe');
    const closeButtons = document.querySelectorAll('.js-video-modal-close');

    if (!triggers.length || !modal || !iframe) return;

    // タッチデバイス かつ 幅768px以下をスマホと判定
    const isMobile = () =>
        window.matchMedia('(max-width: 768px)').matches &&
        ('ontouchstart' in window || navigator.maxTouchPoints > 0);

    const openModal = (videoId) => {
        const mute = isMobile() ? '&mute=1' : '';
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1${mute}&rel=0&playsinline=1`;
        modal.setAttribute('data-open', '');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        modal.removeAttribute('data-open');
        modal.setAttribute('aria-hidden', 'true');
        iframe.src = '';
        document.body.style.overflow = '';
    };

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const videoId = trigger.dataset.videoId;
            if (videoId) openModal(videoId);
        });
    });

    closeButtons.forEach((btn) => {
        btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.hasAttribute('data-open')) {
            closeModal();
        }
    });
};


const main = () => {
    if (!document.querySelector('#page-company')) return;
    outline();
    videoModal();
};

export default main;
